import promoImage from '../../../assets/images/promo-image.png';
import aboutImage from '../../../assets/images/about-image.png';
import howImage0 from '../../../assets/images/how-image-0.jpg';
import howImage1 from '../../../assets/images/how-image-1.jpg';
import howImage2 from '../../../assets/images/how-image-2.jpg';
import socialIcon0 from '../../../assets/images/social-icon-0.svg';
/*import socialIcon1 from '../../../assets/images/social-icon-1.svg';
import socialIcon2 from '../../../assets/images/social-icon-2.svg';
import socialIcon3 from '../../../assets/images/social-icon-3.svg';
import socialIcon4 from '../../../assets/images/social-icon-4.svg';
import socialIcon5 from '../../../assets/images/social-icon-5.svg';*/

import { useEffect, useLayoutEffect, useRef, useContext } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { animateScroll as scroll } from 'react-scroll';

import { ScrollContext } from '../../../context/ScrollProvider';

import useArrayRef from '../../../hooks/useArrayRef';

import getAdvantagesItemsData from '../../../data/advantagesItemsData';
import getReviewsItemsData from '../../../data/reviewsItemsData';

import Section from '../../../components/Section/Section';
import Title from '../../../components/Title/Title';
import Text from '../../../components/Text/Text';
import AdvantagesList from '../../../components/AdvantagesList/AdvantagesList';
import ReviewsList from '../../../components/ReviewsList/ReviewsList';

import './Home.styles.scss';

const Home = () => {
    const { scrollBottom, setScrollBottom } = useContext(ScrollContext);

    gsap.registerPlugin(ScrollTrigger);

    const promoImageRef = useRef();
    const promoInfoRef = useRef();

    const aboutMainRef = useRef();
    const aboutImageRef = useRef();
    const aboutInfoRef = useRef();

    const howSectionRef = useRef();
    const articleRef0 = useRef();
    const articleRef1 = useRef();
    const articleRef2 = useRef();

    const supportSectionRef = useRef();
    const supportTitleRef = useRef();
    const [reviewItemRefs, setReviewsItemRefs] = useArrayRef();

    useLayoutEffect(() => {
        if (window.innerWidth > 996) {
            const promoImageAnimation = gsap.fromTo(
                promoImageRef.current,
                {
                    opacity: 0,
                    x: -100,
                },
                {
                    opacity: 1,
                    x: 0,
                    duration: 0.7,
                    delay: 0.6,
                }
            );

            const promoInfoAnimation = gsap.fromTo(
                promoInfoRef.current,
                {
                    opacity: 0,
                    x: 100,
                },
                {
                    opacity: 1,
                    x: 0,
                    duration: 0.7,
                    delay: 0.6,
                }
            );

            const aboutImageAnimation = gsap.fromTo(
                aboutImageRef.current,
                { opacity: 0, yPercent: 30 },
                {
                    opacity: 1,
                    yPercent: 0,
                    scrollTrigger: {
                        trigger: aboutMainRef.current,
                        start: 'top bottom',
                        end: 'bottom bottom',
                        scrub: true,
                    },
                }
            );

            const aboutInfoAnimation = gsap.fromTo(
                aboutInfoRef.current,
                { opacity: 0, x: -30 },
                {
                    opacity: 1,
                    x: 0,
                    scrollTrigger: {
                        trigger: aboutMainRef.current,
                        start: 'top bottom',
                        end: 'bottom bottom',
                        scrub: true,
                    },
                }
            );

            const firstArticleAnimation = gsap.fromTo(
                articleRef0.current,
                {
                    opacity: 0,
                    yPercent: -40,
                },
                {
                    opacity: 1,
                    yPercent: 0,
                    scrollTrigger: {
                        trigger: howSectionRef.current,
                        start: 'top bottom',
                        end: 'center bottom',
                        scrub: true,
                    },
                }
            );

            const secondArticleAnimation = gsap.fromTo(
                articleRef1.current,
                {
                    opacity: 0,
                    yPercent: -40,
                },
                {
                    opacity: 1,
                    yPercent: 0,
                    scrollTrigger: {
                        trigger: howSectionRef.current,
                        start: 'center bottom',
                        end: 'bottom bottom',
                        scrub: true,
                    },
                }
            );

            const thirdArticleAnimation = gsap.fromTo(
                articleRef2.current,
                {
                    opacity: 0,
                    yPercent: -40,
                },
                {
                    opacity: 1,
                    yPercent: 0,
                    scrollTrigger: {
                        trigger: howSectionRef.current,
                        start: 'center center',
                        end: 'bottom center',
                        scrub: true,
                    },
                }
            );

            const supportTitleAnimation = gsap.fromTo(
                supportTitleRef.current,
                {
                    opacity: 0,
                    yPercent: 30,
                },
                {
                    opacity: 1,
                    yPercent: 0,
                    scrollTrigger: {
                        trigger: supportSectionRef.current,
                        start: 'top bottom',
                        end: 'center center',
                        scrub: true,
                    },
                }
            );

            const supportReviewItemsAnimation = gsap.fromTo(
                reviewItemRefs.current,
                {
                    opacity: 0,
                    xPercent: -20,
                },
                {
                    opacity: 1,
                    xPercent: 0,
                    scrollTrigger: {
                        trigger: supportSectionRef.current,
                        start: 'top bottom',
                        end: 'bottom bottom',
                        scrub: true,
                    },
                }
            );

            return () => {
                promoImageAnimation.kill();
                promoInfoAnimation.kill();
                aboutImageAnimation.kill();
                aboutInfoAnimation.kill();
                firstArticleAnimation.kill();
                secondArticleAnimation.kill();
                thirdArticleAnimation.kill();
                supportTitleAnimation.kill();
                supportReviewItemsAnimation.kill();
            };
        }
    }, [reviewItemRefs]);

    useEffect(() => {
        if (scrollBottom) {
            setTimeout(() => {
                scroll.scrollToBottom();
                setScrollBottom(false);
            }, 100);
        }
    }, [scrollBottom, setScrollBottom]);

    return (
        <>
            <Section name="promo" id="promo" size="medium" additionalClasses={['align-center']}>
                <div className="promo__image flex" ref={promoImageRef}>
                    <img src={promoImage} alt="The SLCK card" />
                </div>

                <div className="promo__info flex flex--column" ref={promoInfoRef}>
                    <Title type="h1" name="promo">
                        Redefine The Way You Present <span className="gold"> Yourself</span>
                    </Title>

                    <Text name="promo">
                        Your image speaks volumes of how you take care of yourself, your business and most importantly,
                        your family. Demonstrate that you value quality while executing it simply, do it with SLCK.
                    </Text>

                    {/*<Link to="register" className="promo__btn">
                        Create
                    </Link>*/}
                </div>
            </Section>

            <Section name="about" id="about" direction="column" additionalClasses={['align-center']}>
                <div className="about__main container container--smaller grid" ref={aboutMainRef}>
                    <div className="about__info flex flex--column" ref={aboutInfoRef}>
                        <Title type="h2" name="about">
                            What is <span className="gold">SLCK</span>?
                        </Title>

                        <Text name="about">
                            SLCK will be your best friend in introducing yourself to clients, business partners and
                            anybody that you’d meet along that way. All you have to do is tap your SLCK card to the
                            receiver’s smartphone and without the need for an app, just the internet. The receiver will
                            be able to save your details, see your bio and even access your social media accounts.
                        </Text>

                        <Text name="about">
                            Did you know that 88% of business cards are thrown within the first week? Imagine the money
                            you’d be saving and also the impact that you’d be having whenever you encounter individuals
                            that would potentially play a crucial role in your career!
                        </Text>
                    </div>

                    <div className="about__image flex" ref={aboutImageRef}>
                        <img src={aboutImage} alt="SLCK app on a phone screen" />
                    </div>
                </div>

                <AdvantagesList arrayOfItems={getAdvantagesItemsData()} />
            </Section>

            <Section name="how" id="how" direction="column" refItem={howSectionRef}>
                <article className="how-article grid align-center justify-space" ref={articleRef0}>
                    <div className="how-article__info flex flex--column">
                        <Title name="how" type="h2" isQuote={true}>
                            Create
                        </Title>

                        {/*<Text name="how">
                            Create your own best Smart Business Card. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </Text>*/}
                    </div>

                    <div className="how-article__image flex">
                        <img src={howImage0} alt="Create your own best Smart Buisness Card." />
                    </div>
                </article>

                <article className="how-article grid align-center justify-space" ref={articleRef1}>
                    <div className="how-article__info flex flex--column">
                        <Title name="how" type="h2" isQuote={true}>
                            Customize
                        </Title>

                        {/*<Text name="how">
                            Create your own best Smart Business Card. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </Text>*/}
                    </div>

                    <div className="how-article__image flex">
                        <img src={howImage1} alt="Create your own best Smart Buisness Card." />
                    </div>
                </article>

                <article className="how-article grid align-center justify-space" ref={articleRef2}>
                    <div className="how-article__info flex flex--column">
                        <Title name="how" type="h2" isQuote={true}>
                            Connect
                        </Title>

                        {/*<Text name="how">
                            Customize your own best Smart Business Card. Lorem ipsum dolor sit amet, consectetur
                            adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </Text>*/}
                    </div>

                    <div className="how-article__image flex">
                        <img src={howImage2} alt="Create your own best Smart Buisness Card." />
                    </div>
                </article>
            </Section>

            <Section
                name="support"
                id="support"
                direction="column"
                additionalClasses={['align-center']}
                refItem={supportSectionRef}>
                <Title type="h2" name="support-main" size="medium" refItem={supportTitleRef}>
                    SLCK Team
                </Title>

                <ReviewsList reviewsArray={getReviewsItemsData()} setRef={setReviewsItemRefs} />

                <div className="support-socials flex flex--column align-center">
                    <Title type="h4" name="support-socials" size="smaller">
                        Connect with us
                    </Title>

                    <ul className="social-list flex align-center">
                        <li className="social-list__item">
                            <a
                                href="https://www.facebook.com/slckmovement"
                                className="social-list__link flex"
                                aria-label="facebook">
                                <img src={socialIcon0} alt="Facebook icon" />
                            </a>
                        </li>

                        {/*<li className="social-list__item">
                            <a href="#" className="social-list__link flex" aria-label="instagram">
                                <img src={socialIcon1} alt="Instagram icon" />
                            </a>
                        </li>

                        <li className="social-list__item">
                            <a href="#" className="social-list__link flex" aria-label="linkedIn">
                                <img src={socialIcon2} alt="LinkedIn icon" />
                            </a>
                        </li>

                        <li className="social-list__item">
                            <a href="#" className="social-list__link flex" aria-label="twitter">
                                <img src={socialIcon3} alt="Twitter icon" />
                            </a>
                        </li>

                        <li className="social-list__item">
                            <a href="#" className="social-list__link flex" aria-label="discord">
                                <img src={socialIcon4} alt="Discord icon" />
                            </a>
                        </li>

                        <li className="social-list__item">
                            <a href="#" className="social-list__link flex" aria-label="telegram">
                                <img src={socialIcon5} alt="Telegram icon" />
                            </a>
                        </li>*/}
                    </ul>
                </div>

                <div className="support-socials__email flex align-center">
                    <Text name="support-socials">Email Us:</Text>

                    <a href="mailto:business@sidewalkdevelopers.io" className="support-socials__email-link text">
                        info@slckinc.com
                    </a>
                </div>
            </Section>
        </>
    );
};

export default Home;